// @ts-strict-ignore
import type { ReactNode } from "react";
import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import { ModularOnboardingModalProvider } from "@clinic/shared/components/ModularOnboardingModalProvider/ModularOnboardingModalProvider";
import type { StaticData } from "@clinic/shared/context/StaticDataContext";
import { StaticDataContext } from "@clinic/shared/context/StaticDataContext";
import { CatalogSearchProvider } from "@emerson/components/Providers/CatalogSearchProvider/CatalogSearchProvider";
import { i18n } from "@emerson/locales/i18n";
import { PageViewLogger } from "@shared/components/PageViewLogger/PageViewLogger";
import { createExperimentVar } from "@shared/context/experiment/experiment.store";

import { WholesaleCheckoutDataProvider } from "./WholesaleCheckoutDataProvider/WholesaleCheckoutDataProvider";

interface Props {
  children: ReactNode;
  roleId: string;
  userId: string;
  storeId: string;
  staticData: StaticData;
}

const Providers = ({ children, roleId, userId, storeId, staticData }: Props) => {
  createExperimentVar({ roleId, userId, storeId });

  useEffect(() => {
    i18n.changeLanguage(global.lng);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <StaticDataContext value={staticData}>
        <ModularOnboardingModalProvider>
          <CatalogSearchProvider>
            <PageViewLogger isUnauth={!roleId}>
              <WholesaleCheckoutDataProvider>{children}</WholesaleCheckoutDataProvider>
            </PageViewLogger>
          </CatalogSearchProvider>
        </ModularOnboardingModalProvider>
      </StaticDataContext>
    </I18nextProvider>
  );
};

export { Providers };
